/** Logo blendet ein */
export const INTRO_ENTER_S = 0.25;

/** Logo bleibt kurz stehen */
export const INTRO_HOLD_S = 0.45;

/** Beige und Logo blenden aus, das Foto darunter ist schon da */
export const INTRO_HANDOFF_S = 0.3;

export const INTRO_TOTAL_S = INTRO_ENTER_S + INTRO_HOLD_S + INTRO_HANDOFF_S;

/** Anteile für die Keyframes: Ende Einblendung, Ende Stand */
export const INTRO_ENTER_T = INTRO_ENTER_S / INTRO_TOTAL_S;
export const INTRO_HOLD_END_T = (INTRO_ENTER_S + INTRO_HOLD_S) / INTRO_TOTAL_S;

/** Navigation erscheint, wenn das Beige ausblendet. */
export const INTRO_HANDOFF_MS = Math.round((INTRO_ENTER_S + INTRO_HOLD_S) * 1000);
export const INTRO_SEQUENCE_MS = Math.round(INTRO_TOTAL_S * 1000);
